export default "__VITE_ASSET__D04J96_J__"